import * as actionTypes from 'constants/ActionTypes';

export function postAnnotations(text, typeLetter, selectedServer, options) {
    return {
        type: actionTypes.POST_ANNOTATIONS.REQUEST,
        text,
        typeLetter,
        selectedServer,
        options,
    };
}

export function removeAnnotations() {
    return {
        type: actionTypes.REMOVE_ANNOTATIONS,
    };
}


// WEBPACK FOOTER //
// ./app/actions/annotations.js